<script setup lang="ts">
import { computed } from 'vue';

import Countdown from '@/shared/components/UI/Countdown.vue';
import { useTranslations } from '@/shared/composables/useTranslations';

const props = defineProps<{
  endDate: string;
}>();

const { t } = useTranslations();

const distanceInMilliseconds = computed(() => {
  const endDateTimestamp = new Date(props.endDate).getTime();
  const nowTimestamp = new Date().getTime();

  return endDateTimestamp - nowTimestamp;
});
</script>

<template>
  <div>
    <div
      class="flex flex-col items-center justify-center rounded-lg bg-primary-50 px-2 py-4 text-base text-primary-900"
    >
      <div>{{ t('product.offer_countdown_text') }}</div>
      <Countdown
        :distance="distanceInMilliseconds"
        class="text-primary-dark-400"
      />
    </div>
  </div>
</template>
